import Layout from "components/layout";
import React from "react";
import Block1 from "./bannerSingleLang";
import Block2 from "./secondFrench";
import Block3 from "./thirdFrench";
import Block4 from "./contentDynamic";
import GetInTouch from "components/getInTouch";
import SEO from "components/seo";
import BottomLogoPanel from "./bottomLogoPanel";

const LanguageDynamicPage = (props) => {
  const {
    pageContext: {
      data: { data },
    },
  } = props;
  return (
    <Layout>
      <SEO
        title={data.meta_title || data.review_title || data.title_block_1}
        description={data.meta_description}
        keywords={data.meta_keywords}
        slug={data.slug}
      />
      <Block1 data={data} />
      <Block2 data={data} />
      <Block3 data={data} />
      <Block4 data={data} />
      <BottomLogoPanel/>
      <GetInTouch />
    </Layout>
  );
};

export default LanguageDynamicPage;
